import { t } from "@lingui/macro";

/* 
  This formats data in the following format examples:
  12 Hours 30 Minutes
  1 Hour 30 Minutes
  12 Hours
  30 Minutes
*/
export const durationDisplayFromMinutesLong = (
  totalMinutes: number | null
): string | null => {
  if (totalMinutes === null) {
    return null;
  }
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${hours >= 1 ? `${hours} ${hours > 1 ? t`Hours` : t`Hour`}` : ""}${
    hours >= 1 && minutes ? " " : ""
  }${
    minutes
      ? `${minutes} ${minutes === 1 ? t`Minute` : t`Minutes`}`
      : hours
      ? ""
      : `0 ${t`Minutes`}`
  }`;
};

/* 
  This formats data in the following format examples:
  12 Hrs 30 Min
  1 Hr 30 Min
  12 Hrs
  30 Min
*/
export const durationDisplayFromMinutesShort = (
  totalMinutes: number | null
): string | null => {
  if (totalMinutes === null) {
    return null;
  }
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${
    hours >= 1 ? hours + (hours > 1 ? ` ${t`Hrs`}` : ` ${t`Hr`}`) : ""
  }${hours >= 1 && minutes ? " " : ""}${
    minutes ? minutes + ` ${t`Min`}` : hours ? "" : `0 ${t`Min`}`
  }`;
};
